import React from "react";

import classes from "./PageSummary.module.css";

const SupplierZoneSummary = () => {
  return (
    <section className={classes.summary}>
      <h2 style={{ fontWeight: "bold" }}>
        Welcome to the @one Alliance Project Viewer Supplier Zone
      </h2>
      <p>
        Here you can access applications, as well as find information and links
        to Engineering procedures and training. All information is tailored to
        you.
      </p>
      <p>
        This area is currently under development and more releases are planned
        over the coming weeks and months. Please check back regularly for new
        updates and look out for communications coming your way.
      </p>
      <p>
        For all questions, or to tell us what you think, please contact
        oneengineering@anglianwater.co.uk
      </p>
    </section>
  );
};

export default SupplierZoneSummary;
